export default "__VITE_ASSET__pZBxxl1L__"